import styles from './PendingHostCard.module.css';

// A grayed placeholder that reserves the second host's slot until it connects.
export function PendingHostCard() {
  return (
    <div className={styles.PendingHostCard_card} aria-hidden={true}>
      <div className={styles.PendingHostCard_name}>
        <span className={styles.PendingHostCard_skeletonDot} />
        <span className={`${styles.PendingHostCard_skeleton} ${styles.PendingHostCard_skeleton___title}`} />
      </div>
      <span className={`${styles.PendingHostCard_skeleton} ${styles.PendingHostCard_skeleton___meta}`} />
    </div>
  );
}
